<template>
  <Teleport to="body">
    <Transition name="sticky-footer">
      <div v-if="show" class="sticky-footer">
        <slot />
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'StickyFooter',
  props: {
    show: { type: Boolean, default: false },
  },
};
</script>
